import { render, staticRenderFns } from "./GroupParamsPage.vue?vue&type=template&id=4f915e97&scoped=true&"
import script from "./GroupParamsPage.vue?vue&type=script&lang=js&"
export * from "./GroupParamsPage.vue?vue&type=script&lang=js&"
import style0 from "./GroupParamsPage.vue?vue&type=style&index=0&id=4f915e97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f915e97",
  null
  
)

export default component.exports